export enum GridDays {
    _30 = 30,
    _60 = 60,
    _90 = 90,
}
